import { Separator } from '@connected/ui/components/separator';

export function ElseField({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex  ">
            <Separator orientation="vertical" className="h-auto h-max-content" />
            <div className="flex ps-6 w-full">
                {children}
            </div>
        </div>
    );
}
